import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "@/components/auth-page";

export const Route = createFileRoute("/reset-password")({
	component: ResetPasswordPage,
	ssr: false,
});

function ResetPasswordPage() {
	return <AuthPage view="RESET_PASSWORD" />;
}
